<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}">
    <!-- <img ref="banner" class="banner" v-if="step > 1" :src="`https://www.succursalesrenault.ma/onlinestore/visuels/${model.nom_lien.toLowerCase()}/banner.jpg`" :alt="model.nom"> -->
    <div v-bem:nav>
      <div class="row">
        <div :class="`col-${($store.getters.model && step > 1) ? '5' : '12'}`" v-bem:progress-wrapper>
          <div v-bem:progress="{[progress]: true, full: (!$store.getters.model || step === 1)}">
            <span v-bem:progress-bar>
              {{progress === 100 ? $t('steps.congrats') : $t('steps.progress')}}
              <span v-bem:progress-number><span>{{progress}}%</span></span>
            </span>
          </div>
        </div>
        <div class="col-7" v-bem:nav:cta v-if="$store.getters.model && step > 1">
          <a href="javascript:;" class="button button--primary icon" @click="showPopin('test-drive')">
            <span class="button__text">
              <inline-svg class="button__icon" :src="require('@/assets/img/icons/steering-wheel.svg')" ></inline-svg> {{$t('cta.testDrive')}}
            </span>
          </a>
          <a href="javascript:;" class="button button--secondary icon" @click="showPopin('brochure')">
            <span class="button__text">
              <img class="button__icon" src="@/assets/img/icons/flyer.svg" alt="car"> {{$t('cta.flyer')}}
            </span>
          </a>
          <a href="javascript:;" class="button button--tertiary icon" @click="showPopin('panorama')">
            <span class="button__text">
              <inline-svg class="button__icon" :src="require('@/assets/img/icons/360-degrees.svg')" ></inline-svg> {{$t('cta.panorama')}}
            </span>
          </a>
          <a v-if="version && step < 4" href="javascript:;" class="button button--rci icon" @click="showSimulator">
            <span class="button__text">
              <img class="button__icon" src="@/assets/img/icons/calculator.svg" alt="calculator"> {{$t('steps.fund')}}
            </span>
          </a>
        </div>
      </div>
    </div>
    <Steps v-if="!loader" :activeStep="step" @prev-step="prevStep" @next-step="nextStep" @stepCliked="goTo" />
    <template v-if="models.length && !loader">
      <Models v-if="step === 1" @next-step="nextStep" @show-form="formVisibility = true" />
      <!-- <Versions v-if="step === 2" @next-step="nextStep" /> -->
      <!-- <Colors v-if="step === 3" @next-step="nextStep" /> -->
      <!-- <InsideView v-if="step === 4" @next-step="nextStep" /> -->
      <!-- <Gallery :step="step" v-if="step === 3 || step === 4" /> -->
      <!-- <Accessories v-if="step === 5" @next-step="nextStep" /> -->
      <Recap v-if="step === 2" :step="step" @next-step="nextStep" />
      <Account v-if="step > 2" :step="step" @next-step="nextStep" />
    </template>
    <Loader v-if="loader" />
    <Avantages />
    <!-- <Faq /> -->
    <FormPopin v-if="formVisibility" @close-clicked="formVisibility = false" />
    <Popin :type="formType" v-if="popinVisibility" @close-clicked="popinVisibility = false" />
    <SimulatorWidget v-if="version && step < 4" />
    <MaintenancePopin v-if="maintenance" />
    <TradeInPopin v-if="tradeInPopinVisibility" @close-clicked="tradeInPopinVisibility = false" />
  </div>
</template>

<script>
import EventBus from '@/event-bus'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'PreOrder',
  components: {
    Steps           : () => import('@/components/PreOrder/Steps.vue'),
    Models          : () => import('@/components/PreOrder/Models.vue'),
    Versions        : () => import('@/components/PreOrder/Versions.vue'),
    Colors          : () => import('@/components/PreOrder/Colors.vue'),
    Gallery         : () => import('@/components/PreOrder/Gallery.vue'),
    InsideView      : () => import('@/components/PreOrder/InsideView.vue'),
    Accessories     : () => import('@/components/PreOrder/Accessories.vue'),
    Recap           : () => import('@/components/PreOrder/Recap.vue'),
    Account         : () => import('@/components/PreOrder/Account.vue'),
    Avantages       : () => import('@/components/Avantages.vue'),
    Faq             : () => import('@/components/Faq.vue'),
    FormPopin       : () => import('@/components/FormPopin.vue'),
    Popin           : () => import('@/components/Popin.vue'),
    SimulatorWidget : () => import('@/components/SimulatorWidget.vue'),
    MaintenancePopin: () => import('@/components/MaintenancePopin'),
    Loader          : () => import('@/components/Loader'),
    TradeInPopin    : () => import('@/components/PreOrder/TradeInPopin.vue'),
  },
  data: () => ({
    loader: false,
    step: 1,
    formType: '',
    formVisibility: false,
    popinVisibility: false,
    tradeInPopinVisibility: false,
    maintenance: false,
  }),
  methods: {
    prevStep(to) {
      if (to < 1) this.$router.push({ path: `/${this.$i18n.locale}` });
      else {
        this.step--;
        if (this.step === 1) this.$router.replace(`/${this.$i18n.locale}/commande`).catch(() => {});
        if (this.step === 2) this.$router.replace(`/${this.$i18n.locale}/commande/${this.model.nom_lien.toLowerCase()}/${this.version.nom_version}`).catch(() => {});
        // setTimeout(() => {
        //   const top = document.querySelector('.app-header').clientHeight + this.$refs.banner.clientHeight;
        //   window.scrollTo({ top });
        // }, 0);
      }
    },
    nextStep() {
      this.step++;
      // if (this.step === 3) this.showSimulator()
      // setTimeout(() => {
      //   const top = document.querySelector('.app-header').clientHeight + this.$refs.banner.clientHeight;
      //   window.scrollTo({ top });
      // }, 0);
    },
    goTo(index) {
      if (this.$store.state.selected.version.id) this.step = index;
    },
    showPopin(type) {
      this.formType = type
      this.popinVisibility = true
    },
    showSimulator() { EventBus.$emit('show-simulator-widget') }
  },
  computed: {
		...mapGetters([
      'models',
      'model',
      'version',
      'color',
      'accessories',
      'options',
      'mensualite',
      'trade',
    ]),
		...mapGetters({
      mode: 'maintenance'
    }),
    progress() { return (this.step/4).toFixed(2)*100 }
  },
  created() {
    this.maintenance = this.mode
    this.tradeInPopinVisibility = this.trade
    if (this.$route.params.form) {
      this.step = 2
      this.$router.replace(`/${this.$i18n.locale}/commande/${this.model.nom_lien.toLowerCase()}/${this.version.nom_version}`)
    }
    else if (this.$route.params.mensualite) {
      this.loader = true
      const params = this.$route.params
      const mId = params.modelId
      const vId = params.versionId

      let storeUser = localStorage.getItem('storeUser')
      storeUser = storeUser ? JSON.parse(storeUser) : { id : '' }
      const mensualite = {
        type   : params.type,
        formule: params.formule,
        output : { mensualite_all_inclusive: parseFloat(params.mensualite) },
        input  : {
          apport: params.apport,
          duree : params.duree,
          prix_du_vehicule: parseFloat(params.prix),
        },
      }
      axios.get('https://succursalesrenault.ma/onlinestore/admin/public/api/shopsucc')
        .then(({data}) => data.filter(brand => brand.LibelleMarque.toUpperCase() === process.env.VUE_APP_THEME.toUpperCase())[0])
        .then(({RefModeles}) => {
          this.$store.dispatch('setModels', RefModeles)
          const model = this.models.find(m => m.nom_lien === mId)
          this.$store.dispatch('setModel', model)
          const version = model.voitures.find(v => v.nom_version.toLowerCase() === vId)
          this.$store.dispatch('setVersion', version)
          this.step = 2
          this.$store.dispatch('setTrade', true)
          setTimeout(() => {
            this.loader = false
            this.$store.dispatch('setMonthlyPayment', mensualite)
            this.$store.dispatch('setApport', mensualite.input.apport)
          }, 0);
        })
        .catch(err => console.error(err))
    }
    else {
      // const mId = this.$route.params.modelId || (this.model ? this.model.nom_lien.toLowerCase() : '')
      const mId = this.$route.params.modelId
      // const vId = this.$route.params.versionId || (this.version ? this.version.nom_version : '')
      const vId = this.$route.params.versionId
      // const cId = this.color ? this.color.id : ''
      // const accessories = this.accessories
      // const options = this.options
      // const mensualite = this.mensualite
      let storeUser = localStorage.getItem('storeUser')
      storeUser = storeUser ? JSON.parse(storeUser) : { id : '' }
      axios.get('https://succursalesrenault.ma/onlinestore/admin/public/api/shopsucc')
        .then(({data}) => data.filter(brand => brand.LibelleMarque.toUpperCase() === process.env.VUE_APP_THEME.toUpperCase())[0])
        .then(({RefModeles}) => {
          this.$store.dispatch('setModels', RefModeles)
          if (mId) {
            const model = this.models.find(m => m.nom_lien.toLowerCase() === mId)
            if (model && !model.stock_epuise && model.voitures.length > 0) {
              this.$store.dispatch('setModel', model)
              if (vId) {
                const version = model.voitures.find(v => v.nom_version.toLowerCase() === vId)
                if (version) {
                  this.$store.dispatch('setVersion', version)
                  this.step = 2
                  // if (accessories.length) this.$store.dispatch('setAccessories', accessories)
                  // if (options.length) this.$store.dispatch('setOptions', options)
                  // if (mensualite) this.$store.dispatch('setMonthlyPayment', mensualite)
                  // if (!cId) this.step = 3
                  // else {
                  //   this.$store.dispatch('setColor', cId)
                  //   this.step = 4
                  // }
                } else {
                  // this.$store.dispatch('setVersion', '')
                  this.step = 2
                }
              } else {
                // this.$store.dispatch('setVersion', '')
                this.step = 2
              }
            } else {
              this.$store.dispatch('setModel', '')
              this.step = 1
            }
          } else {
            this.$store.dispatch('setModel', '')
            this.step = 1
          }
        })
        .catch(err => console.error(err))
    }
  }
}
</script>

<style scoped lang="scss">
// .banner {
//   margin: 0 auto;
//   display: table;
// }
.pre-order {
  &__progress {
    $progress: &;
    width: 100%;
    max-width: rem(690);
    background-color: lighten($dark-gray, 30%);
    border-width: rem(10) rem(8);
    border-color: $white;
    border-style: solid;
    font-size: 0;
    &-bar {
      position: relative;
      display: inline-block;
      width: 0;
      background-color: rgba(var(--primary-color), 1);
      color: $white;
      text-align: center;
      padding-bottom: rem(4);
      @include font-size(12);
      transition: width 0.4s ease-out;
    }
    &-number {
      @extend %transform-center-vertical;
      display: inline-block;
      right: rem(-20);
      background-color: $white;
      border-radius: 50%;
      width: rem(28);
      height: rem(28);
      text-align: center;
      box-shadow: 0 0 rem(2) rgba($black, 0.3);
      span {
        color: $main-color;
        width: 100%;
        @include font-size(10);
        font-weight: bold;
        @extend %transform-center;
      }
    }
    &--full {
      margin: 0 auto;
    }
    &--25 {
      #{$progress}-bar {
        width: 25%;
      }
    }
    &--50 {
      #{$progress}-bar {
        width: 50%;
      }
    }
    &--75 {
      #{$progress}-bar {
        width: 75%;
      }
    }
    &--80 {
      #{$progress}-bar {
        width: 80%;
      }
    }
    &--100 {
      #{$progress}-bar {
        width: 100%;
        background-color: $success-color;
      }
      #{$progress}-number {
        display: none;
      }
    }
  }
  &__nav {
    position: sticky;
    top: 0;
    padding: rem(12) rem(16);
    background-color: lighten($dark-gray, 50%);
    z-index: 6;
    &-cta {
      text-align: right;
      .button + .button {
        margin-left: rem(8);
      }
    }
  }
  &--rtl {
    .pre-order {
      &__progress {
        &-bar {
          padding-bottom: rem(1);
          padding-top: rem(3);
        }
        &-number {
          right: unset;
          left: rem(-20);
        }
      }
      &__nav {
        &-cta {
          text-align: left;
          .button + .button {
            margin-left: 0;
            margin-right: rem(8);
          }
        }
      }
    }
  }
  @include breakpoint(1410) {
    &__progress {
      margin: 0 auto;
      &-wrapper {
        padding: rem(16) rem(8);
      }
    }
    &__nav {
      padding: 0;
      .row [class^="col"] {
        width: 100%;
      }
      &-cta {
        text-align: center;
        .button {
          max-width: unset;
          min-width: unset;
          margin: 0;
          padding-left: rem(36);
          &__text {
            text-align: center;
          }
          & + .button {
            margin: 0;
          }
        }
        @for $i from 1 through 4 {
          .button:first-child:nth-last-child(#{$i}) {
            width: percentage(1 / $i);
            & ~ .button {
              width: percentage(1 / $i);
            }
          }
        }
      }
    }
    &--rtl {
      .pre-order {
        &__nav {
          &-cta {
            .button + .button {
              margin: 0;
            }
          }
        }
      }
    }
  }
  @include breakpoint(880) {
    &__nav {
      &-cta {
        .button {
          min-width: calc(100% / 3);
          &--rci {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            min-width: 100%;
          }
        }
      }
    }
  }
  @include breakpoint('charmander') {
    &__nav {
      &-cta {
        .button {
          vertical-align: bottom;
          &--rci {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            min-width: 100%;
          }
        }
      }
    }
  }
  @include breakpoint(425) {
    .button {
      .button__text {
        @include font-size(11);
      }
    }
  }
}
</style>